import { money } from "@/lib/currency";

export const LineAddons = ({ addons, cur, className = "text-[#6B6560]" }) =>
  addons?.length ? (
    <span data-testid="line-addons" className={`block text-xs ${className}`}>
      {addons.map((a) => `+ ${a.name}${a.price ? ` (${money(a.price, cur)})` : ""}`).join(", ")}
    </span>
  ) : null;
